// Golf 5 (Turks): toestemming van een ouder voor een kind onder 16 (eigen login, foto) en de
// pagina met de privacyverklaring. Zelfde vorm als golf5App.nl.ts; warme sen-vorm zoals de rest van
// de Turkse app. De toestemmingsteksten tellen mee in CHILD_CONSENT_TEXT_HASHES.
export const appChildConsentTr = {
    version: '2026-09-26.1',
    title: '{name} için izin',
    intro: '{name} 16 yaşından küçük. Kendi girişi veya fotoğrafı için önce bir ebeveynden izin istiyoruz.',
    notNeeded: '{name} 16 yaşında veya daha büyük; kendi girişine ve fotoğrafına kendisi karar verir.',
    login: {
        title: 'Kendi girişi',
        text: 'Kendi girişiyle {name} uygulamaya telefondan veya bilgisayardan kendisi girebilir. {name} o zaman ailenin takvimini, görevlerini, puanlarını ve mesajlarını görür; izinleri, e-posta adreslerini veya sağlık bilgilerini asla görmez. AMUMIN B.V. izni kimin, ne zaman verdiğini ve hangi metni okuduğunu saklar. İzni her zaman geri çekebilirsin: giriş o anda çalışmaz.',
        check: '{name} adlı çocuğun ebeveyni veya vasisiyim ve kendi girişi için izin veriyorum.',
    },
    photo: {
        title: 'Avatar olarak fotoğraf',
        text: 'İzinle simge yerine {name} adlı çocuğun fotoğrafını kullanabilirsin. Fotoğraf o zaman uygulamada ve duvardaki panoda görünür: tabletin olduğu odadaki herkes onu görür. Fotoğraftaki konumu ve diğer bilgileri sileriz ve fotoğrafı kimseyle paylaşmayız. AMUMIN B.V. izni kimin, ne zaman verdiğini ve hangi metni okuduğunu saklar. İzni her zaman geri çekebilirsin: fotoğraf o anda silinir.',
        check: '{name} adlı çocuğun ebeveyni veya vasisiyim ve fotoğraf için izin veriyorum.',
    },
    ask: 'İzin ver',
    give: 'İzin ver',
    cancel: 'Şimdi değil',
    withdraw: 'Geri çek',
    withdrawConfirm: 'Evet, geri çek',
    withdrawLogin: 'Kendi girişi için verdiğin izni geri çekmek istiyor musun? {name} adlı çocuğun girişi o anda çalışmaz.',
    withdrawPhoto: 'Fotoğraf için verdiğin izni geri çekmek istiyor musun? {name} adlı çocuğun fotoğrafı o anda silinir.',
    none: 'Henüz izin yok',
    givenBy: '{name} izin verdi, {date}',
    givenByYou: 'Senin iznin, {date}',
    givenOn: 'İzin tarihi: {date}',
    hasLogin: '{name} artık kendi girişine sahip.',
    hasPhoto: '{name} artık bir fotoğrafa sahip.',
    given: 'İzin verildi',
    withdrawn: 'İzin geri çekildi',
    withdrawnLogin: '{name} adlı çocuğun girişi artık çalışmıyor.',
    withdrawnPhoto: '{name} adlı çocuğun fotoğrafı silindi.',
    checkRequired: 'Önce kutuyu işaretle.',
    privacyLink: 'Gizlilik bildiriminde daha fazlası',
    /** Review g5 sec r2: een kindlogin van vóór 0044 zonder toestemming. */
    loginWithoutConsent: '{name} için izin olmadan açılmış bir giriş var: izin ver veya girişi kapat.',
    disableLogin: 'Girişi kapat',
    disableLoginAsk: '{name} için giriş kapatılsın mı? Giriş hemen çalışmayı durdurur.',
    disableLoginConfirm: 'Evet, kapat',
    loginDisabled: '{name} için giriş kapatıldı.',
    /** Gezin: de lijst met zulke kinderen (namen eronder). */
    missingList: 'Bu çocuklar için izin olmadan açılmış bir giriş var: izin ver veya girişi kapat.',
    gateLogin: 'Bu kişinin kendi girişi var. 16 yaşından küçük bir çocuk için önce bir ebeveynin izni gerekir: önce girişi kaldırın, sonra yaşı değiştirin ve ardından izin verin.',
    gatePhoto: '16 yaşından küçük bir çocuğun fotoğrafı yalnızca bir ebeveynin izniyle kullanılabilir. Önce izin verin veya fotoğrafı kaldırın.',
};
export const appPrivacyStatementTr = {
    title: 'Gizlilik bildirimi',
    back: 'Uygulamaya dön',
    concept: 'Taslak, hukukçu tarafından inceleniyor',
    version: 'Sürüm {version} · {date}',
    contents: 'İçindekiler',
    onlyDutch: 'Bu gizlilik bildirimi henüz Türkçe değil. Aşağıda Hollandaca metni görüyorsun; İngilizceyi de seçebilirsin.',
    showDutch: 'Nederlands',
    showEnglish: 'English',
    placeholder: 'daha sonra doldurulacak',
};
//# sourceMappingURL=golf5App.tr.js.map